import { render, staticRenderFns } from "./base.vue?vue&type=template&id=30a51a4a"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports